export default {
  action: {
    addReceipt: 'Add receipt',
    approve: 'Approve',
    attach: 'Attach',
    back: 'Back',
    companyReports: 'Company reports',
    cancelRequest: 'Cancel request',
    cardTransfer: 'Recall funds',
    chooseEmailed: 'Choose from emailed receipts',
    close: 'Close',
    connectXero: 'Connect to Xero',
    createBudget: 'Create budget',
    decline: 'Decline',
    delete: 'Delete',
    deleteBudget: 'Delete budget',
    discard: 'Discard',
    disconnectXero: 'Disconnect from Xero',
    enableBeta: 'Enable Beta Features',
    faq: 'FAQ',
    forgotPassword: 'Forgot password?',
    funds: 'Funds',
    hideInactiveBudgets: 'Hide inactive budgets',
    inviteUsers: 'Invite users',
    manage: 'Manage',
    open: 'Open',
    openFile: 'Open {file}',
    pendingRequests: 'Pending Requests',
    register: 'Register',
    report: 'Report',
    requests: 'Requests',
    resend: 'Resend it',
    returnUnspent: 'Return unspent funds ({amount})',
    save: 'Save',
    saveChanges: 'Save changes',
    searchCategory: 'Search for category',
    searchRequest: 'Search for request',
    selectCategory: 'Select a category',
    selectRequest: 'Select a request',
    sendEmailReport: 'Email Report',
    sendXeroReport: 'Send to Xero',
    showInactiveBudgets: 'Show inactive budgets',
    selectFile: 'Select file',
    settings: 'Settings',
    signIn: 'Sign in',
    submitRequest: 'Submit request',
    tagCategory: 'Tag category',
    tagRequest: 'Tag request',
    takePicture: 'Take picture',
    thisBudget: 'This Budget',
    transfer: 'Transfer',
    transferFromBudget: 'Transfer from this budget',
    transferToBudget: 'Transfer to this budget',
    topUpCard: 'Top up card',
    updateCard: 'Update card details',
    viewReceipt: 'View receipt',
    viewRequests: 'View Requests',
    videoTutorials: 'Video Tutorials'
  },
  dialog: {
    cancelRequest: 'Are you sure, you want to cancel this request?',
    cardTopup: 'You have topped up {user}\'s card with {amount} from "{budget}".',
    createReportSuccess: 'The report was created successfully. You will receive an email with the link to the documents.',
    createXeroReportSuccess: 'The Xero report is now being created. It should show up in Xero over the next five minutes.',
    deleteBudget: 'Are you sure, you want to delete this budget?',
    deleteReceipt: 'Are you sure you want to delete this receipt?',
    deleteTag: 'Are you sure you want to delete this tag?',
    makeRequestSuccess: 'Your new request was sent successfully.',
    paymentDetails: 'You have to provide valid payment details, before adding more users.',
    recall: 'You have recalled {amount} from {user} card.',
    saveChanges: 'Do you want to save changes before leaving?',
    supportError: 'Sorry, there was an error while sending your support request: {error}. Please email your support request to support@getaio.co.uk.'
  },
  label: {
    accountNo: 'Account No.',
    activeUsers: 'No active users | One active user | {count} active users',
    actualSpend: 'Actual spend',
    all: 'All',
    allocated: 'Allocated',
    addNote: 'Add a note',
    address: 'Address',
    approved: 'Approved',
    amount: 'Amount',
    balance: 'Balance',
    budget: 'Budget | Budgets',
    budgetFrom: 'Budget from',
    budgetFilter: 'Filter by budget',
    by: 'by {user} on {date}',
    cardBrand: 'Brand/type',
    cardDetails: 'Current card details',
    cardExpires: 'Expires',
    cardNumber: 'Number',
    category: 'Category',
    declined: 'Declined',
    description: 'Description',
    dob: 'Date of birth',
    email: 'Email',
    english: 'English',
    expiresEnd: 'EXPIRES END',
    faceId: 'FaceID Authentication',
    fingerprint: 'Fingerprint Authentication',
    firstName: 'First name',
    from: 'From',
    german: 'German',
    kybStatus: 'KYB Status',
    language: 'Language',
    lastName: 'Last name',
    lastTransaction: 'Last Transaction',
    location: 'City or location',
    managedBy: 'Managed by',
    monthYear: 'MONTH/YEAR',
    name: 'Name',
    notes: 'Notes',
    otpCode: 'Please enter the one time pin that has been emailed to you',
    password: 'Password',
    pendingApproval: 'Pending Approval',
    processedBy: '{decision} by {user} on {date}',
    processedOn: '{decision} on {date}',
    phone: 'Phone',
    postcode: 'Postcode',
    reason: 'Reason',
    receipt: 'Receipt',
    reference: 'Reference',
    refunded: 'Refunded',
    registrationNo: 'Registration number',
    request: 'Request',
    requested: 'Requested',
    requestFrom: 'Request from',
    returned: '{amount} has been returned',
    showPending: 'Pending',
    showProcessed: 'Processed',
    sortCode: 'Sort Code',
    spendingCategories: 'Spending categories',
    spendReason: 'Reason for spend',
    spent: 'Spent',
    subject: 'Subject',
    tagName: 'Enter a name for the new tag:',
    to: 'To',
    toDate: 'To',
    touchId: 'TouchID Authentication',
    user: 'User | Users',
    userAccess: 'Users with access',
    xeroBankAccount: 'Xero Bank Account',
    xeroChartAccounts: 'Chart of Accounts',
    xeroOrganisation: 'Xero Organisation'
  },
  menu: {
    budgets: 'Budgets',
    company: 'Company',
    help: 'Help',
    logout: 'Logout',
    myCard: 'My Card',
    myProfile: 'My Profile',
    myRequests: 'My Requests',
    myTransactions: 'My Transactions',
    reports: 'Reports',
    requests: 'Requests',
    settings: 'Settings',
    spend: 'Spend',
    users: 'Users'
  },
  option: {
    budgetReport: 'Budget',
    cardIssue: 'Card Issue',
    expenseReport: 'Expense',
    generalSuggestion: 'General Suggestion',
    month: 'Month',
    other: 'Other',
    stylingIssue: 'Styling Issue',
    technicalIssue: 'Technical Issue',
    xeroReport: 'Xero',
    year: 'Year'
  },
  placeholder: {
    chooseBudget: 'Choose a budget',
    chooseUser: 'Choose a user',
    email: 'Your email',
    enterEmail: 'Enter email address',
    enterMessage: 'Enter message to user',
    enterComment: 'Enter comment',
    enterNotes: 'Enter notes',
    otpCode: 'Code',
    password: 'Your password',
  },
  text: {
    amountOnCard: 'There is currently {balance} on {user} card. How much would you like to withdraw?',
    betaFeatures: "We're working on new features that we hope you'll love. We'll try our best to make sure these work but there may still be rough edges. Enable this if your company would like to try them out early, you can disable it at any time.",
    bankTransfer: 'You can top up your company float by making a bank transfer to your aio* account:',
    budgetReport: 'Budget report contains all transactions in and out of \'{name}\' over the specified time frame.',
    didntReceiveCode: "Didn't receive a code?",
    expenseReport: 'Expense report contains all card transactions from all users in the company over the specified time frame.',
    forwardEmail: [
      'You can also forward email receipts to ',
      '.'
    ],
    noManageRequests: 'Nobody in your team has made a request yet. As soon as this happens, you will get a notification and it will be visible here.',
    noMyRequests: [
      'You haven\'t requested any money so far. Tap + to',
      'make a request',
      'now.'
    ],
    noSpend: 'You haven\'t spent any money with your aio* card yet. As soon as you pay for something, you will get a notification and your transactions will be visible here.',
    noTags: 'Tags you add will appear here',
    pendingCard: `<b>Once you receive your new card please activate the card and confirm your PIN by:</b><br>
      <ul>
        <li>Calling card services on 02034755351</li>
        <li>Press 1</li>
        <li>Option 1</li>
        <li>Follow the instructions to activate your card (you will need to enter your 16 digit card number and use your 6 digit date of birth as your passcode DDMMYY)</li>
      </ul>
      <br>
      <b>You can confirm your PIN by:</b><br>
      <ul>
        <li>Calling card services on 02034755351</li>
        <li>Press 1</li>
        <li>Option 4</li>
        <li>Enter your 16 digit card number</li>
        <li>Enter your passcode (your 6 digit date of birth – DDMMYY)</li>
      </ul>
      <br>You can change your PIN at any highstreet ATM offering the service.`,
    price: '<strong>£5</strong> per active user per month',
    unclassifiedExpenses: '{count} transactions are missing a category. Future transactions will be added to Xero but any changes made to old ones won\'t be re-sent.',
    validPayment: 'We require valid payment details in order to issue new aio* cards and charge for usage.',
    verifying: [
      'We are verifying your company. Once the check is complete we\'ll let you know and you will be able to transfer funds to your aio* account.',
      'In the meantime you can invite your team on the \'Users\'-page within \'Organisation\'. They will receive an invitation to register. When they complete their profile we will be able to issue them cards.'
    ],
    xeroChartAccounts: 'Xero Chart of Accounts are imported into aio* as categories.',
    xeroIntegration: [
      'You are currently not connected to any Xero organisation.',
      'Please press the button and enter your Xero account credentials to grant aio* access.',
      'Xero Chart of Accounts will be imported into aio* as categories.'
    ],
    xeroNotConnected: [
      'You are currently not connected to any Xero organisation. Please proceed to \'@:title.xeroIntegration\' in',
      '\'@:menu.company\'',
      'and establish a connection first.'
    ],
    xeroReport: 'Only card transactions that are not in Xero yet will be exported.'
  },
  title: {
    addCard: 'Add new credit or debit card',
    addTag: 'Creating a tag',
    adminContact: 'Admin contact details',
    balanceAvailable: '{budget} ({amount} available)',
    betaFeatures: 'Beta Features',
    budgetTransfer: 'Budget transfer',
    budgetSettings: 'Budget settings',
    cardStatus: {
      title: 'Card Status: <b>{status}</b>',
      pending: 'pending',
      Active: 'active',
      Cancelled: 'cancelled',
      Expired: 'expired',
      Lost: 'lost',
      Stolen: 'stolen',
      Suspended: 'frozen',
      undefined: ''
    },
    cardTransfer: 'Transfer from card',
    currentOfTotal: '{current} of {total}',
    company: 'Company',
    companyInfo: 'Company Info',
    createBudget: 'Create new budget',
    dateRange: 'Date range',
    floatTransfer: 'Float bank transfer',
    guides: 'Guides',
    help: 'Help',
    info: 'Info',
    invitedOn: 'Invitation sent on {date}',
    inviteUsers: 'Invite users',
    invitedUsers: 'Invited users',
    makeRequest: 'Make a request',
    manage: 'Manage',
    manageBudget: 'Manage {budget}',
    manageRequests: 'Manage requests',
    manageTags: 'Manage Tags',
    myCard: 'My Card',
    myRequests: 'My Requests',
    myTransactions: 'My Transactions',
    noCard: '{user} hasn\'t got an aio* card yet.',
    noPreview: 'No preview available',
    noTransaction: 'No transactions',
    or: 'or',
    overview: 'Overview',
    pageNotFound: 'Sorry, page not found',
    paymentDetails: 'Payment Details',
    report: 'Report',
    reportFor: 'Report for {0}',
    reportIssue: 'Report Issue',
    reportType: 'Type of report',
    request: 'No requests | One request | {count} requests',
    requestDetails: 'Request details',
    settings: 'Settings',
    spend: 'Spend',
    topUpCard: 'Top up card',
    transactionDetails: 'Transaction Details',
    unclassifiedExpenses: 'Unclassified Expenses',
    uploadedOn: 'uploaded on {date}',
    userCard: '{user}\'s card',
    userDetails: 'User details',
    visibility: 'Visible to users',
    welcome: 'Welcome to aio*',
    xeroIntegration: 'Xero Integration',
    your: 'your'
  },
  validation: {
    amount: 'Please select a valid amount.',
    chooseBudget: 'Please choose a budget.',
    chooseUser: 'Please choose a user.',
    dateRange: 'Please choose a valid date range.',
    destinationBudget: 'Please choose a budget as destination.',
    email: 'Please enter a valid email address.',
    managers: 'Please choose at least one manager for this budget.',
    name: 'Please enter a name.',
    originBudget: 'Please choose a budget as origin.',
    reason: 'Please enter a reason.',
    users: 'Please choose users who can access this budget.'
  },
}
